import { render, staticRenderFns } from "./we-image-view.vue?vue&type=template&id=4663cbae"
import script from "./we-image-view.vue?vue&type=script&lang=js"
export * from "./we-image-view.vue?vue&type=script&lang=js"
import style0 from "./we-image-view.vue?vue&type=style&index=0&id=4663cbae&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports